<template>
  <b-modal
    id="modal-form"
    :title="type === 'add' ? 'Agregar Servicio' : 'Editar Servicio'"
    no-close-on-backdrop
    hide-footer
  >
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(onSubmit)">
        <b-row>
          <b-form-group class="col-md-12" label="Icono:" label-for="name">
            <ValidationProvider name="Icono" rules="required" v-slot="{ errors }">
              <b-form-file
                id="icon"
                v-model="form.icon"
                :state="Boolean(form.icon)"
                placeholder="Elija un archivo o suéltelo aquí..."
                drop-placeholder="Suelta el archivo aquí..."
                @change="onChangeFile"
              ></b-form-file>
              <div class="invalid-feedback">
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </b-form-group>
          <b-form-group class="col-md-12" label="Descripción:" label-for="name">
            <ValidationProvider name="Descripción" rules="required" v-slot="{ errors }">
              <b-form-input
                v-model="form.description"
                type="text"
                :class="errors.length > 0 ? ' is-invalid' : ''"
              />
              <div class="invalid-feedback">
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </b-form-group>
          <div class="col-md-12 w-100">
            <b-button type="submit" variant="primary" class="float-right">
              {{ type === "add" ? "Guardar" : "Actualizar" }}
            </b-button>
          </div>
        </b-row>
      </b-form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import { Toast } from './../../../mixins/toast'
import api from './../../../services/api'

export default {
  components: {},
  props: {
    type: {
      type: String,
      required: true,
      default: 'add'
    },
    data: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      form: {
        icon: null,
        description: ''
      }
    }
  },
  watch: {
    data: function (newValue, oldValue) {
      this.form = newValue
    }
  },
  methods: {
    onChangeFile (e) {
      this.form.icon = e.target.files[0]
    },
    onSubmit () {
      if (this.type === 'add') {
        this.saveData()
      } else {
        this.updateData()
      }
    },
    async saveData () {
      try {
        const formData = new FormData()
        Object.entries(this.form).forEach(([key, value]) => {
          formData.append(key, value)
        })

        await api.post('/services', formData)

        Toast.fire({
          icon: 'success',
          title: 'Servicio Guardado'
        })

        this.$bvModal.hide('modal-form')
        this.$emit('getData')
      } catch (error) {
        Toast.fire({
          icon: 'error',
          title: 'Error'
        })
      }
    },
    async updateData () {
      try {
        const formData = new FormData()
        Object.entries(this.form).forEach(([key, value]) => {
          formData.append(key, value)
        })

        await api.post(`/services/${this.data.id}/update`, formData)

        Toast.fire({
          icon: 'success',
          title: 'Servicio Actualizado'
        })

        this.$bvModal.hide('modal-form')
        this.$emit('getData')
      } catch (error) {
        Toast.fire({
          icon: 'error',
          title: 'Error'
        })
      }
    }
  }
}
</script>
